// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Field, useField } from "formik";
import PropTypes from "prop-types";

import { Input } from "components/form/elements";
import { trans } from "src/translations";
import { isRequired, pipeValidators } from "utils/validation";

import styles from "./ScopeField.scss";

const FIELD_NAME = "scope";
const FIELD_NAME_START = "scope.start";
const FIELD_NAME_END = "scope.end";

export const ScopeField = ({ isReadonly }) => {
  const [startField, startMeta, startHelpers] = useField({
    name: FIELD_NAME_START,
  });
  const [endField, endMeta, endHelpers] = useField({
    name: FIELD_NAME_END,
  });

  const validate = (values) => {
    const errors = pipeValidators(
      isRequired("start"),
      isRequired("end")
    )(values);
    if (errors.start || errors.end) {
      return errors;
    }
    return undefined;
  };

  return (
    <Field name={FIELD_NAME} validate={validate}>
      {() => (
        <div className={styles.wrapper}>
          <Input
            {...startMeta}
            type="date"
            look="simple"
            label={trans.CAMPAIGN_EDIT__FIELD_SCOPE_START()}
            value={startField.value}
            props={{
              max: endField.value || "",
            }}
            onChange={(e) => startHelpers.setValue(e.target.value)}
            readOnly={isReadonly}
            required
            className={styles.input}
            dataTestId="campaign-scope-start"
          />
          <Input
            {...endMeta}
            type="date"
            look="simple"
            label={trans.CAMPAIGN_EDIT__FIELD_SCOPE_END()}
            value={endField.value}
            props={{
              min: startField.value || "",
            }}
            onChange={(e) => endHelpers.setValue(e.target.value)}
            readOnly={isReadonly}
            required
            className={styles.input}
            dataTestId="campaign-scope-end"
          />
        </div>
      )}
    </Field>
  );
};

ScopeField.propTypes = {
  isReadonly: PropTypes.bool,
};
